import React from 'react';

import { H1, H2 } from '../ui/headings';
import { FullHeightSectionWrapper } from '../ui/wrappers';

import { insertSocialItems } from '../utils/insert-social-items';

const Home = () => (
    <FullHeightSectionWrapper id='home'>
        <div className='animated-title'>
            <div className='text-top'>
                <div>
                    <H1>Hello,</H1>
                    <H1>I'm Reito Serizawa</H1>
                </div>
            </div>
            <div className='text-bottom'>
                <H2>Software Engineer</H2>
                {insertSocialItems({ home: true })}
            </div>
        </div>
    </FullHeightSectionWrapper>
);

export default Home;
